import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@digdir/designsystemet-react';

import { OppvarmingOlje } from '../../../../../../types/registration/userInput';
import {
  AccentedTableRow,
  Capitalize,
  LeftBorderCell
} from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface OppvarmingOljeProps {
  olje: OppvarmingOlje | undefined;
}
export const OppvarmingOljeView: FC<OppvarmingOljeProps> = ({ olje }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tekniskutstyr.oppvarming.olje' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });

  return (
    olje && (
      <Fragment>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={2}>{t('header')}</TableCell>
        </AccentedTableRow>

        {olje.kamin && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('kamin.label')}</TableCell>
            </AccentedTableRow>
            <TableRow>
              <TableCell>{t('kamin.termostatstyring.label')}</TableCell>
              <LeftBorderCell>{t(`kamin.termostatstyring.${olje.kamin.termostatstyring}`)}</LeftBorderCell>
            </TableRow>
          </Fragment>
        )}

        {olje.kjel && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('kjel.label')}</TableCell>
            </AccentedTableRow>
            {olje.kjel.installasjonsAr && (
              <TableRow>
                <TableCell>{t('kjel.installasjonsar')}</TableCell>
                <LeftBorderCell>{olje.kjel.vetInstallasjonsAr ? olje.kjel.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: olje.kjel.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {olje.kjel.bruk && (
              <TableRow>
                <TableCell>{t('kjel.bruk.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.bruk.${olje.kjel.bruk}`)}</LeftBorderCell>
              </TableRow>
            )}
            {olje.kjel.varmesystemBruk && (
              <TableRow>
                <TableCell>{t('kjel.varmesystembruk')}</TableCell>
                <LeftBorderCell><Capitalize>{olje.kjel.varmesystemBruk}</Capitalize></LeftBorderCell>
              </TableRow>
            )}
            {olje.kjel.gulvvarme && (
              <TableRow>
                <TableCell>{t('kjel.gulvvarme.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.gulvvarme.${olje.kjel.gulvvarme}`)}</LeftBorderCell>
              </TableRow>
            )}
            {olje.kjel.radiator && (
              <TableRow>
                <TableCell>{t('kjel.radiator.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.radiator.${olje.kjel.radiator}`)}</LeftBorderCell>
              </TableRow>
            )}
            {olje.kjel.varmesentral && (
              <TableRow>
                <TableCell>{t('kjel.varmesentral.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.varmesentral.${olje.kjel.varmesentral}`)}</LeftBorderCell>
              </TableRow>
            ) &&
              olje.kjel.varmesentralInstallasjonsAr && (
                <TableRow>
                  <TableCell>{t('kjel.varmesentral.varmesentralInstallasjonsAr')}</TableCell>
                  <LeftBorderCell>{olje.kjel.vetVarmesentralInstallasjonsAr ? olje.kjel.varmesentralInstallasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: olje.kjel.varmesentralInstallasjonsAr })}</LeftBorderCell>
                </TableRow>
              )}

            {olje.kjel.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('kjel.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>{t(`kjel.${olje.kjel.serviceGjennomfortSiste2Ar}`)}</LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  );
};
